import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Cursor from "@/components/Cursor";
import { MediaProvider } from "@/components/MediaViewer";

const TITLES = [
  ["/about", "About"], ["/services", "Services"], ["/gallery", "Gallery"], ["/studio", "Studio"],
  ["/reels", "Social"], ["/contact", "Contact"], ["/accessibility", "Accessibility"],
  ["/maker", "Maker"], ["/kingsley/fitting", "Book a fitting · M. Kingsley Studio"],
  ["/kingsley", "M. Kingsley Studio"], ["/payment", "Order · M. Kingsley Studio"], ["/kit-phaedra", "Resources"],
];

function usePageTitle() {
  const { pathname } = useLocation();
  useEffect(() => {
    const hit = TITLES.find(([p]) => pathname.startsWith(p));
    document.title = hit ? `${hit[1]} — Phaedra Paulson` : "Phaedra Paulson — Stylist, Maker, M. Kingsley Studio";
  }, [pathname]);
}

export default function Layout({ children }) {
  usePageTitle();
  return (
    <MediaProvider>
      <div className="relative min-h-screen bg-paper text-ink">
        <a href="#main" data-testid="skip-to-content" className="skip-link">Skip to main content</a>
        <div className="noise-overlay" aria-hidden="true" />
        <Cursor />
        <Nav />
        <main id="main" tabIndex={-1} className="outline-none">{children}</main>
        <Footer />
      </div>
    </MediaProvider>
  );
}
